import React from "react";
import axios from 'axios';
import {toast} from 'react-toastify'

class Register extends React.Component{

    state = { email:'', password:'', passwordCon:'', name:'', emailErr:'', passwordErr:'', nameErr:'',
        passwordConErr:''
    }

    onFormSubmit = async(e) => {
        try{
            e.preventDefault();
            let {
                email,
                password,
                name,
                passwordCon
            } = this.state;
            console.log('submit');
            
            if(password.length < 6){
                this.setState({passwordErr:'Must be atleast 6 characters'})
            }else if(!email.includes('@')){
                this.setState({emailErr:'Enter valid email'})
            }else if(name.length < 3){
                this.setState({nameErr:'Enter valid name'})
            }else if(passwordCon !== password){
                this.setState({passwordConErr:"password doesn't match"})
            }else{
                let response = await axios.post('https://scrape.businesstoys.in/student', {
                    name,
                    email,
                    password
                });

                if(response.data.status === 'created'){
                    toast.success('Account Created, \n Will be approved within 24 hours', {
                        position: "top-center",
                        autoClose: false,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        });
                }else if(response.data.status === 'exist'){
                    toast.error('This email exists, \n Contact your mentor ', {
                        position: "top-center",
                        autoClose: false,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        });
                }else{
                    toast.error('Something went wrong, try after some time', {
                        position: "top-center",
                        autoClose: false,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        });
                }

            }
        }catch(err){
            console.log(err);
            toast.error(' Something went wrong, try after some time', {
                position: "top-center",
                autoClose: false,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                });
        }

    }

    render(){
        return(
            <section className="register">
                <div className="register__container">
                    <div className="register__container__txt">
                        <h1>
                            An Exclusive Job aggrigator 
                            <br className="tablet-off" />
                            platform for &nbsp; 
                            <a href="https://businesstoys.in/" target="_blank" >
                                Business Toys &nbsp;
                            </a>
                            <br className="tablet-off" />
                            students
                        </h1>
                        <h3>
                            10000+ Job Opportunities
                        </h3>
                        <h3>
                            From 10+ Job Search Platform
                        </h3>
                        <h3>
                            Personalized Recommendation
                        </h3>

                    </div>
                    <form className="register__container__form" onSubmit={this.onFormSubmit} >
                        <h2>Register</h2>
                        <div className="register__container__form__ip">
                            <label>Email</label>
                            <input type="email" 
                                required
                                value={this.state.email}
                                onChange={(e)=>this.setState({email:e.target.value})}
                                name="email" placeholder="edward@example.com"  />
                            <span>
                                {this.state.emailErr &&  <i className="fas fa-info-circle"></i> }
                                {this.state.emailErr}
                            </span>
                        </div>
                        <div className="register__container__form__ip">
                            <label>Password</label>
                            <input type="password" 
                                required
                                value={this.state.password}
                                onChange={e => this.setState({password:e.target.value})}
                                name="password" placeholder="Must be atleast 6 characters" />
                            <span>
                                { this.state.passwordErr && <i className="fas fa-info-circle"></i>}
                                {this.state.passwordErr}
                            </span>
                        </div>
                        <div className="register__container__form__ip">
                            <label>Confirm Password</label>
                            <input type="password" 
                                required
                                value={this.state.passwordCon}
                                onChange={e => this.setState({passwordCon:e.target.value})}
                                name="confirm-password" placeholder="Both passwords must match" />
                            <span>
                                { this.state.passwordConErr && <i className="fas fa-info-circle"></i>}
                                {this.state.passwordConErr}
                            </span>
                        </div>
                        <div className="register__container__form__ip">
                            <label>Name</label>
                            <input type="text"
                                required 
                                value={this.state.name}
                                onChange={e=>this.setState({name:e.target.value})}
                                name="name" placeholder="Edward"  />
                            <span>
                                {this.state.nameErr &&  <i className="fas fa-info-circle"></i> }
                                {this.state.nameErr}
                            </span>
                        </div>
                        <button>
                            Register
                        </button>
                    </form>
                </div>
            </section>
        )
    }
};

export default Register;